import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Loader } from 'src/components/ui'

const AuthLayout = () => {
  // const { data: user, isLoading, error } = useGetUserQuery(undefined)
  // if (isLoading) return <Loader />
  // if (user) return <Navigate to={'/'} />

  return (
    <Suspense fallback={<Loader />}>
      <main className="md:p-8 bg-page">
        <Outlet />
      </main>
    </Suspense>
  )
}

export default AuthLayout
